import { createAction, props } from '@ngrx/store';

export const setFullscreenState = createAction(
  '[Fullscreen] BOM Optimizer fullscreen mode set',
  props<{ fullscreenState: boolean }>()
);
